import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/blog13-1.png";
import image5 from "../../../../assets/images/blog13-5.png";
import image4 from "../../../../assets/images/blog13-4.png";
import image3 from "../../../../assets/images/blog13-3.png";
import image12 from "../../../../assets/images/blog13-12.png";
import image16 from "../../../../assets/images/blog13-16.png";
import image22 from "../../../../assets/images/blog13-22.png";
import image23 from "../../../../assets/images/blog13-23.png";
import image15 from "../../../../assets/images/blog13-15.png";
import image6 from "../../../../assets/images/blog13-6.png";
import image21 from "../../../../assets/images/blog13-21.png";
const Blog13 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook: 7th April, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Rates, Rotation & Risk-Off Rumbles – The Bulls Blink
        </p>
        <div className="subHeader">
          <p className=""> Macro moves, chart setups, and sentiment shocks for the week of April 7th, 2025</p>
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">The Bull Trap Snaps as Macro Reality Bites</p>
              <p>
                It was a brutal week for the Bulls. SPX cracked below support, Bonds surged/Yields cracked, gold exploded to fresh highs, and the market’s soft-landing fantasy took a gut punch. The
                MAG7 cracked, volatility returned, and cracks in the macro wall are widening into chasms.
              </p>
              <p>
                The April calendar doesn’t ease up either—CPI and FOMC minutes land this week, alongside bond auctions and Fed speakers. With data weakening and inflation proving stubborn, markets are
                betting rates will be cut but fighting with Powell and his team suggesting the opposite.
              </p>
              <p>Time to recalibrate. Here’s what matters this week—through the lens of price, policy, and positioning.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Key Market Themes: Cracks in the Foundation</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">1. MAG7 Cracks: “Back to the Pack” Is No Longer Just a Catchphrase</p>
                <p>
                  The mega-cap resilience that carried the market is finally cracking. Last week, tech giants like<span className="highlightedText"> Apple, NVIDIA, Tesla, </span>
                  and <span className="highlightedText"> Meta</span> suffered sharp drawdowns, dragging down the cap-weighted S&P.
                </p>

                <p>
                  The equal-weight S&P has started to outperform the headline index again suggesting that even in the across the board selling, MAG7 is losing out. This isn’t your standard
                  rotation—it’s a <span className="highlightedText"> sentiment unwind </span>as the “magnificent” narrative loses its lustre for now.
                </p>
                <p>Fewer stocks are trading above key moving averages post Liberation Day. A reversion to the mean looks to be in full swing.</p>
              </div>
              <div className="relatedImg">
                <img
                  src={image1}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image1)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv">
                <p className="highlightedText_header">2. Gold Breaks Out (Again): A Statement, Not Just a Trade</p>
                <p>
                  <span className="highlightedText"> Gold soared through $3,100</span>
                  printing new all-time highs and confirming its macro dominance. This isn’t a one-off spike—it has been a structural move driven by{" "}
                  <span className="highlightedText"> central bank demand, real yield dislocations,</span>
                  and a global chase for monetary hedges but cracks have appeared.
                </p>

                <p>
                  <span className="highlightedText"> US yields have started the new week climbing,</span>
                  gold is trading mixed with many spooked by margin selling in the equity fallout at the end of the week. Clear signs that we are at an important level The price action confirms it’s
                  not just about inflation anymore. Gold is now outperforming both <span className="highlightedText"> real yields</span> and <span className="highlightedText"> risk assets</span>{" "}
                  —which makes it the cleanest macro long in this environment.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image5}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image5)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">3. VIX Snaps Back: Volatility Is No Longer Cheap</p>
                <p>
                  The<span className="highlightedText"> VIX surged above 40 following the break into the 20s in the previous week.</span>
                  Vol curves are steepening again. After weeks of compression, <span className="highlightedText"> demand for downside protection</span> has returned in force.
                </p>

                <p>
                  This isn’t your usual “buy-the-dip” backdrop anymore. Volatility flows—especially<span className="highlightedText"> gamma positioning </span> —are twisting the price action in both
                  directions. Market makers are adjusting rapidly, causing exaggerated intraday swings.
                </p>
                <p>
                  And with <span className="highlightedText">CPI </span>and <span className="highlightedText"> Fedspeak</span> on deck, the re-awakening in vol is just commencing. Expect more
                  two-sided tape and air pockets on even minor news surprises.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image4}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv">
                <p className="highlightedText_header">4. Bonds Break: Global growth fears surge into bonds</p>
                <p>
                  The
                  <span className="highlightedText">US 10Y yield spiked to 4.4%</span>
                  entering last week, marking a major breakdown in the bond market’s dovish fantasy. We had it as an expected consolidation channel that would fade.
                </p>

                <p>
                  A week later and the Tariff fallout brought in concerns for a US and potentially global growth slowdown. Potentially the return of QE if yields test that 4.5% level again.Market
                  hopes for rate cuts jumped to potentially 4 for the year and possibly 50bp in June whatever the Fed is saying outwardly. Sticky inflation and solid jobs data are boxing the Fed into
                  a corner.
                </p>
                <p>
                  A curveball is Global Money Supply, Raoul Pal has long opined that this leads risk assets by 10-12 weeks and we are in the sweet spot for some mopping up. Bitcoin is his flavour but
                  the markets look like a sweet shop of bargains
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image3}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image3)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">5. Crude Oil’s Whiplash: Geopolitics vs Macro Reality</p>
                <p>
                  Crude oil had a wild ride—initially rallying on the Middle East risk headlines before fading hard. The <span className="highlightedText">failure to hold gains</span>
                  is telling: even geopolitical tension isn’t enough to override growing <span className="highlightedText"> demand-side worries.</span>
                </p>

                <p>
                  US inventory builds, lacklustre PMI data, and cracks in consumer spending all point to macro headwinds for crude. The recent drop in oil suggests markets are now pricing in broader
                  <span className="highlightedText"> growth fears</span> over supply shocks. Plus OPEC+ and the Saudis showing signs of capitulating on price and volumes
                </p>
                <p>
                  Watch this week’s<span className="highlightedText"> CPI and PPI </span> closely. If crude continues to fade, it could be a signal for a deeper slowdown, that’s still being masked by
                  headline inflation prints.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image12}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image12)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr className="divisionLine" />

          <div className="subHeader">
            <p className="highlightedBoldText">Technical & Sentiment Analysis: Bearish Momentum Building</p>

            <div className="subHeader">
              <div className="contentDivWrapper ">
                <div className="contentDiv">
                  <p className="highlightedText_header">SPX Breakdown: Bearish Structure in Focus</p>
                  <p>SPX lost key support last week and closed below the trend. The structure now aligns with a bearish ABC or possible start of a larger impulsive wave down.</p>
                  <div className="imageWrapper">
                    <div className="relatedImg">
                      <img
                        src={image16}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image16)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>
                    The 5150–5200 zone is key. A break here opens the downside into the 4950–5000 Fib cluster which looks like hitting on Monday post Asian meltdown. Bears are finally in control—can
                    CPI deliver a miracle? Or will Trump clarity emerge.
                  </p>
                </div>
              </div>
            </div>

            <div className="subHeader">
              <div className="contentDivWrapper">
                <div className="contentDiv">
                  <p className="highlightedText_header">Internals Flash “Danger”</p>
                  <p>
                    SPX internals—such as the percentage of stocks above their 50-day moving average and relative strength—showed a modest weakening in breadth, but not extreme stress, pre-Tariffs.
                    Participation remains positive overall, especially in cyclicals and financials, though momentum in some sectors is slowing. That quickly reversed on Thursday with the Tariff
                    fallout hitting reverse engine and into defensives. Friday saw full risk on plus margin calls morph into panic
                  </p>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="subHeader">
              <div className="contentDivWrapper row_reverse">
                <div className="contentDiv">
                  <p className="highlightedText_header">Dow & Industrials: Panic ahead from the signals?</p>
                  <p>Dow Momentum Collapsing The DOW, often a proxy for industrial strength, is crumbling. Momentum signals are now outright bearish. </p>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <p>This isn’t just tech weakness, it’s broader market stress.</p>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Last Week’s Recap: Rotation, Reversal & Red Flags</p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">SPX</span> ATH then reversed,<span className="highlightedText">Oil </span>reversed hard,<span className="highlightedText">VIX </span>jumped
                    </p>
                  </li>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Yields </span>plunged on global growth and US recession odds hit 50/50. Bonds a safe haven
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Japan </span>joined the party with a sharp equity correction.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={image15}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image15)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <p className="highlightedBoldText">Upcoming Week Ahead: Event Risk Explosion</p>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Monday, Apr 7 – No major data</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>Markets may digest last week’s moves with positioning ahead of CPI.</p>
                  </li>
                  <li className="themesPointer">
                    <p>Watch US Consumer Credit late in the day for any cracks</p>
                  </li>
                </ul>
              </div>
              <div className="listImgWrapper">
                <p className="highlightedText_header">Tuesday, Apr 8 – NFIB Small Business Optimism</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>A window into Main Street. Watch hiring intentions and price plans closely.</p>
                  </li>
                </ul>
              </div>
              <div className="listImgWrapper">
                <p className="highlightedText_header">Wednesday, Apr 9 – NZ and INR rate cuts + FOMC Minutes</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      Global Central Bank test…25bp cuts expected, will they do more? Fed minutes may show internal policy rifts but we have even more confusion since. The dollar is still in downtrend
                      with bounces not holding. EZ CPI should allow for cuts
                    </p>
                  </li>
                </ul>
              </div>
              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="listImgWrapper">
                <p className="highlightedText_header">Thursday, Apr 10 – CPI + Jobless Claims</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      A key inflation/labour combo. Expect rate cut odds to shift sharply based on these prints. The Fed needs room on inflation to press go on any rescue cuts. Federal Job cuts not
                      really showing up yet
                    </p>
                  </li>
                </ul>
              </div>
              <div className="listImgWrapper">
                <p className="highlightedText_header">Friday, Apr 11 – PPI + UoM Consumer Sentiment</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>PPI will complete the set for inputs to PCE</p>
                  </li>
                </ul>
              </div>
              <p>UoM Sentiment was already shaky—another drop could reinforce the recession narrative. Kugler acknowledged the 1Y and 5Y inflation breakouts in this survey…the Fed do watch!!</p>
              {/* <div className="relatedImg">
                <img
                  src={""}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg("")}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Actionable Takeaways: Time to Play Defense</p>
                <div className="listImgWrapper">
                  <p className="highlightedText_header">A rally toward 5285–5300 without new news is a likely sell.</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        SPX market structure was indeed broken. Tariff headlines broke the support and the new LL has caused a double extension sell off. Momentum has now put in a LL so some form of
                        relief rally is possible. Bear markets go up more days than down but impulsive moves down tend to wipe out any gains. If Trump stands firm expect a Low retest below
                        5000…Rallies should be held around 5300 for now
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="listImgWrapper">
                  <p className="highlightedText_header">Gold is still the macro hedge of choice, but profit-taking and margin calls get in the way.</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        Watch for a dip toward 2700-2800 as a reload zone. A retest of 3167 ATH is crucial for whether we have topped out an 18 month bull run. Rate cuts are flip flopping and Powell
                        vetoed early cuts on Friday, but QE is a possibility if Bonds start being sold from overseas. Gold has seen margin call selling to finance other positions…A hotter CPI and DXY
                        bounce could trigger a temporary flush. Structurally, new highs are in play medium term if rate cut expectations rebuild.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="listImgWrapper">
                  <p className="highlightedText_header">FX signals defensive rotation—stay long JPY and CHF?</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        USDJPY tested 145 and opens up room for a break lower. Yen is bid as BOJ tightens liquidity. Look for signs the DXY resumes downtrend for new Yen strength. CHF remains a tricky
                        risk-off long, as SNB rhetoric could muddy the waters.
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="listImgWrapper">
                  <p className="highlightedText_header">Volatility trades are back on.</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        With CPI, FOMC minutes, and fragile sentiment into earnings, straddles or gamma setups offer attractive risk/reward. VIX breakouts are causing extreme market hedging.
                        Sequential 4%+ down days followed by a Monday Asian follow through —look for a bit of mean reversion and a relief rally but the market is still short gamma and needs to
                        re-balance
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="listImgWrapper">
                  <p className="highlightedText_header">Oil breakdown due a pause but fade it</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        The break of the support zone around $65 has seen a test below $60. The Saudis have started to slash their own prices…we are close to the end of the expected 5 waves down. Look
                        for a re-test of $64 channel bottom then global demand worries probably take-over again
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />
        <span className="highlightedText">Final Verdict:Stay Nimble, Stay Realistic</span>
        <p>
          The market is recalibrating to a stronger-than-expected macro backdrop. While risks are rising, the bull trend hasn’t fully broken yet. This is a time for defensive positioning, selective
          risk-taking, and short-term tactical plays over broad exposure.
        </p>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1VVkJu9gXLUl91DOHTexX77OHJSvlgMsH-weQ4bCXl3k/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog13;
